import React from 'react';
import { CustomColumnProps } from '@ihsm/ui-shared';
import { ReactDataGrid } from '../../ReactDataGrid';

export const MarketDataGrid: React.FC<{
  data: any[];
  columns: CustomColumnProps[];
}> = ({ data, columns }) => (
  <ReactDataGrid
    showSortingControls
    data={data}
    columns={columns}
    virtualScroll
  />
);

export const MarketDataGridMemoized = React.memo(MarketDataGrid);
